import { useEffect, useState } from "react";
import { Singleton } from "../../../../../core/services/Singleton";
import { ForpoService } from "../service/ForpoService";
import { useDashboardStore } from "../../../../pages/hooks/useDashboardStore";

export const useCredit = () => {
    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new ForpoService();
    const [lista, setLista] = useState([]);
    const [state, setState] = useState<number>(1);
    const [bean, setBean] = useState<any>({
        Name: "",
        Descripcion: "",
        State: 1,
        InitDate: single.getCurrenDate(),
        EndDate: '',
        BudgetValue: 0,
        IDEmployee: single.getAccountID(),
        QuotaRange: 1,
        MinValue: 0.0,
        MaxValue: 0.0,
        ScaleValue: 0.0,
        RateValue: 0.0,
        Since: "",
    });


    useEffect(() => {
        getLista();
    }, []);
    useEffect(() => {
        getLista();
    }, [state]);


    const idBean = "IDCredit";
    const [estados,setEtados] = useState<any>([
        {id:1,name:"ABIERTO"},
        {id:2,name:"CERRADO"},
        {id:3,name:"DECLINADO"},
        {id:4,name:"TERMINADO"},
        {id:5,name:"APROBADO"},
        {id:6,name:"PENDIENTE COMITE"},
        {id:7,name:"NEGADO"},
        {id:8,name:"APROVACION COMITE"},
    ]);

    const setRowBean = (bean: any) => {
        setBean(bean);
    };

    const getLista = () => {
        setLoading(true);
        service.getCreditRender(null, null, {State:state}).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let list = resp.DataBeanProperties.ObjectValue;
                    list.forEach((e: any) => {
                        e.DataBeanProperties.AccountName =
                            (e.DataBeanProperties.Name1 ?? '') + " " +
                            (e.DataBeanProperties.Name2 ?? '') + " " +
                            (e.DataBeanProperties.Surname1 ?? '') + " " +
                            (e.DataBeanProperties.Surname2 ?? '')

                       
                    })
                    setLista(list);
                }
                else{setLista([])}
                setLoading(false);
            });
    };

    const head = [
        { title: "ID", property: idBean ,visible:false},
        { title: "Solicitud", property: "AlphaCode" },
        { title: "Estado del credito", property: "EstadoCredito" },
        { title: "Identificacion", property: "Nit" },
        { title: "Afiliado", property: "AccountName" },
        { title: "Prestamo Total", property: "Amount" },
        { title: "Cuota", property: "FeeValue", visible: false },
        { title: "Tasa de Interes", property: "RateValue", visible: false },
        { title: "Numero de Cuotas", property: "QuotaCredit" },
        // { title: "Total de intereses", property: "TotalRate" },
        { title: "Token", property: "TokenCredit" },
        { title: "Fecha de registro de Token", property: "TokenDate", visible: false },
        { title: "Funcionario que registra Token", property: "RegisterCredit",visible:false },

    ];

    return {
        single,
        service,
        lista,
        estados,        
        setLista,
        state,
        setState,
        bean,
        setBean,
        idBean,
        head,
        setRowBean,
    };
};
